import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Stack } from '@mui/material';

import { Button, Divider } from '@occc/ui-design-system';
import { KeyboardDatePicker, Select } from '@occc-app/design-system';

import {
  createdAtFilterOptions,
  expireAtFilterOptions,
  sourceTypeFilterOptions,
  stateFilterOptions,
} from './constants';
import { DateRange, VouchersFilterFormProps, VouchersFilterFormValues } from './types';

export const VouchersFilterForm: React.FC<VouchersFilterFormProps> = ({
  onSubmit,
  onReset,
  initialValues,
}) => {
  const renderForm: FormRenderProps<VouchersFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form, values }: FormRenderProps<VouchersFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <Stack component='form' onSubmit={handleSubmit} spacing={2} width={400} px={2} py={3}>
          <Select name='sourceType' label='Source Type' data={sourceTypeFilterOptions} />
          <Select name='state' label='State' data={stateFilterOptions} />

          <Divider />
          <Select name='createdAt.range' label='Creation Date' data={createdAtFilterOptions} />
          {values.createdAt.range === DateRange.Custom && (
            <Stack direction='row' justifyContent='space-between' spacing={2}>
              <KeyboardDatePicker name='createdAt.start' />
              <KeyboardDatePicker name='createdAt.end' />
            </Stack>
          )}

          <Divider />
          <Select name='expireAt.range' label='Expiration Date' data={expireAtFilterOptions} />
          {values.expireAt.range === DateRange.Custom && (
            <Stack direction='row' justifyContent='space-between' spacing={2}>
              <KeyboardDatePicker name='expireAt.start' />
              <KeyboardDatePicker name='expireAt.end' />
            </Stack>
          )}

          <Stack direction='row' spacing={2} justifyContent='flex-end'>
            <Button size='small' color='error' onClick={reset}>
              Reset
            </Button>
            <Button type='submit' size='small' color='primary'>
              Apply
            </Button>
          </Stack>
        </Stack>
      );
    },
    [onReset],
  );
  return (
    <Form<VouchersFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
